const scrollToElement = (
  element: HTMLElement | null,
  delayMs: number | undefined = 100
) => {
  if (!element) {
    return;
  }
  setTimeout(() => {
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  }, delayMs);
};

export { scrollToElement };
